import { FaDownload } from "react-icons/fa";
import React from "react";

export const DownloadButtonReport = props => {
  return (
    <div style={{ display: "flex", justifyContent: "center", margin: 0 }}>
      <button
        className="btn btn--secondary navbar-button"
        style={{ width: "100%", height: "35px", marginLeft: "15px" }}
      >
        <FaDownload /> Download Report
      </button>
    </div>
  );
};
